export const contestPosition = [
  { label: "Primero", value: "FIRST_PLACE" },
  { label: "Segundo", value: "SECOND_PLACE" },
  { label: "Tercero", value: "THIRD_PLACE" },
  { label: "Ninguno", value: "WITHOUT_POSITION" }
];
